
window.Chart = require('chart.js');
require('chartjs-plugin-annotation')
import pattern from 'patternomaly';
window.pattern = pattern

import '../css/tailwind.css'
import '../sass/style.scss'
import PackageDevelopments from './app/PackageDevelopments.js';

require('./app/bootstrap3shim')

  window.APPLICATION = 
  {

    _PATH_PREFIX: '',

    _DATA_PREFIX: '',

    // The date picker
    _datepicker: null,

    // The password version
    _PASSWORD_VERSION: '1.0.0',

    // no clicking off custom modals
    _noClickOff: false,

    _init: function (controller, action)
    {

      if (undefined !== this._APPLICATION && 'function' === typeof this._APPLICATION._init)
      {
        this._APPLICATION._init(controller, action)
      }

      if (undefined !== this[controller])
      {

        if ('function' === typeof this[controller]._init)
        {
          this[controller]._init()
        }

        if (undefined !== this[controller][action] && 'function' === typeof this[controller][action]._init)
        {
          this[controller][action]._init()
        }

      }

    },
 
    _APPLICATION: require('./app/_APPLICATION'),

    SignUp: require('./app/SignUp'),

    Password: require('./app/Password'),

    Account: require('./app/Account'),

    Calendar: require('./app/Calendar'),

    Application: require('./app/Application'),

    MasterView: require('./app/MasterView'),

    BackhaulDash: require('./app/BackhaulDash'),

    PONData: require('./app/PONData'),

    Signups: require('./app/SignUps'),

    SignupAccounts: require('./app/SignupAccounts'),

    Comms: require('./app/Comms'),

    Report: require('./app/Report'),

    Development: require('./app/Development'),

    Plot: require('./app/Plot'),

    Bom: require('./app/Bom'),

    OrderForm: require('./app/OrderForm'),

    MailingLists: require('./app/MailingLists'),

    News: require('./app/News'),

    ServiceSummary: require('./app/ServiceSummary'),

    Installation: require('./app/Installation'),

    AccountGroup: require('./app/AccountGroup'),

    Administration: require('./app/Administration'),

    Engineer: require('./app/Engineer'),

    Visits: require('./app/Visits.js'),

    Product: require('./app/Product.js'),

    CashPayment: require('./app/CashPayment.js'),

    MiFi: require('./app/MiFi.js'),

    AbortiveVisit: require('./app/AbortiveVisit.js'),

    PlotIssue: require('./app/PlotIssue.js'),

    PropertyDatabase: require('./app/PropertyDatabase.js'),

    MasterPremiseDatabase: require('./app/MasterPremiseDatabase.js'),

    ISP: require('./app/ISP.js'),

    Delay: require('./app/Delay.js'),

    AreaCode: require('./app/AreaCode.js'),

    FibreNode: require('./app/FibreNode.js'),
 
    ONT: require('./app/ONT.js'),

    ProductsUsed: require('./app/ProductsUsed.js'),

    DriversReport: require('./app/DriversReport.js'),

    Splitter: require('./app/Splitter.js'),

    FibrePod: require('./app/FibrePod.js'),

    SocialTariff: require('./app/SocialTariff.js'),

    WifiGuarantee: require('./app/WiFiGuarantee.js'),
    PackageDevelopments: require('./app/PackageDevelopments.js'),
    CoinsDevelopment: require('./app/COINSDevelopment.js'),

  }
